import React from "react";
import { cn } from "../../../lib/utils";
import { STEP_LABELS, TOTAL_STEPS } from "../constants";

interface StepIndicatorProps {
  currentStep: number;
}

export function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <div className="px-6 pt-3 pb-5 bg-muted/20">
      {/* Bar segments */}
      <div className="flex gap-1.5">
        {Array.from({ length: TOTAL_STEPS }, (_, i) => {
          const step = i + 1;
          const isComplete = step < currentStep;
          const isCurrent = step === currentStep;

          return (
            <div
              key={step}
              className={cn(
                "h-1 flex-1 rounded-full transition-all duration-500",
                isComplete
                  ? "bg-primary"
                  : isCurrent
                  ? "bg-primary"
                  : "bg-muted"
              )}
            />
          );
        })}
      </div>

      {/* Label */}
      <p className="text-xs text-muted-foreground mt-2 text-center">
        Step {currentStep} of {TOTAL_STEPS} — {STEP_LABELS[currentStep - 1]}
      </p>
    </div>
  );
}
